"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TopicLabel = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicLabel"));

var _IdeationStatus = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/IdeationStatus"));

var _ContentStatus = require("../ContentStatus");

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _TopicContent = require("@insided/deprecated-preact-components/topic-list-view/TopicContent");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StatusPill = _interopRequireDefault(require("@insided/shared/uikit/StatusPill"));

var _common = require("@insided/shared/utils/common");

var _contentType = require("@insided/shared/utils/contentType");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicListItemCardBody = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicListItemCardBody, _Component);

  var _super = _createSuper(TopicListItemCardBody);

  function TopicListItemCardBody() {
    var _this;

    (0, _classCallCheck2.default)(this, TopicListItemCardBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderStatusBadge", function () {
      var topic = _this.props.topic;
      var contentType = topic.contentType;

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      if (contentType === 'idea') {
        return (0, _preact.h)(_IdeationStatus.default, {
          topic: topic
        });
      }

      if ((0, _contentType.isConversationOrDiscussion)(contentType) && isBugContentTypeEnabled && topic !== null && topic !== void 0 && topic.bugStatus) {
        return (0, _preact.h)(_StatusPill.default, {
          label: topic.bugStatus.name,
          backgroundColor: topic.bugStatus.backgroundColor,
          textColor: topic.bugStatus.textColor
        });
      }

      return (0, _preact.h)(_ContentStatus.TopicTooltip, {
        topic: topic
      });
    });
    return _this;
  }

  (0, _createClass2.default)(TopicListItemCardBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          topic = _this$props.topic,
          attachmentCdn = _this$props.attachmentCdn,
          isUnreadPostCountEnabled = _this$props.isUnreadPostCountEnabled,
          isNew = _this$props.isNew,
          clickCallback = _this$props.clickCallback;
      var featuredImage = topic.featuredImage,
          featuredImageAltText = topic.featuredImageAltText,
          content = topic.content,
          topicUrl = topic.topicUrl;

      var trimmedContent = _htmlParser.default.stripHtml(content.trim());

      var hasBeenRead = !(isUnreadPostCountEnabled && isNew);
      return (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(topicUrl === null || topicUrl === void 0 ? void 0 : topicUrl.destination),
        className: "topic-list-item-card_body",
        onClick: function onClick() {
          return clickCallback === null || clickCallback === void 0 ? void 0 : clickCallback();
        },
        role: "button",
        onKeyDown: function onKeyDown(e) {
          return e.key === 'Enter' && (clickCallback === null || clickCallback === void 0 ? void 0 : clickCallback());
        }
      }, (0, _preact.h)("div", {
        className: "topic-list-item-card_body_main"
      }, (0, _preact.h)("div", {
        className: "topic-list-item-card_title-container"
      }, (0, _preact.h)("span", {
        className: (0, _classnames.default)('topic-list-item-card_title-text', {
          'topic-list-item-card_title-text--read': hasBeenRead
        })
      }, topic.title), (0, _preact.h)(_TopicLabel.default, {
        topic: topic
      }), this.renderStatusBadge()), (0, _preact.h)("div", {
        className: "topic-list-item-card_text-preview"
      }, trimmedContent)), featuredImage && (0, _preact.h)(_LazyImage.default, {
        type: "img",
        src: (0, _absoluteUrlRuntime.resolveUrl)((0, _TopicContent.getImageUrl)(featuredImage, '480', attachmentCdn)),
        className: "topic-list-item-card_body_featured-image topic-image",
        alt: featuredImageAltText,
        title: topic.title
      }));
    }
  }]);
  return TopicListItemCardBody;
}(_preact.Component);

var _default = TopicListItemCardBody;
exports.default = _default;